import AbarthAutomotive from './WorkshopsData/abarthautomotive.data';
import TyrePlusCaulfield from './WorkshopsData/tyreplusCaulfield.data';
import TZAutomotiveRepairs from './WorkshopsData/tzautomotiverepairs.data';
import MalvernTyreAndService from './WorkshopsData/malverntyreandservice.data';
import RingwoodServiceCentre from './WorkshopsData/ringwoodServiceCentre.data';
import TyrePlusMackay from './WorkshopsData/tyreplusMackay.data';
import TyrePlusCairns from './WorkshopsData/tyreplusCairns.data';

const workshops = [
    AbarthAutomotive,
    TyrePlusCaulfield,
    TZAutomotiveRepairs,
    MalvernTyreAndService,
    RingwoodServiceCentre,
    TyrePlusMackay,
    TyrePlusCairns
];

export default workshops;
